// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const castform_sunny: PokeData = {
  "id": 10013,
  "name": "castform-sunny",
  "height": 3,
  "weight": 8,
  "base_experience": 147,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "ember",
    "water-gun",
    "hydro-pump",
    "blizzard",
    "fire-blast",
    "powder-snow",
    "rain-dance",
    "sunny-day",
    "hail",
    "weather-ball",
    "hurricane"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "ember",
    "hydro-pump",
    "blizzard",
    "rain-dance",
    "sunny-day",
    "hurricane",
    "fire-spin",
    "fire-punch",
    "flamethrower",
    "magma-storm",
    "blaze-kick"
  ],
  "evolution_chain": {
    "id": 179,
    "item": null,
    "species": [
      {
        "name": "castform",
        "order": 379,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 133,
    "speed": 133,
    "ability_power": 133
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
